<template>
    <!--div class="work-proj-item" :class="{'active' : myScreen == actScreen && (scroll == 0 || overMe == 0),
    'past' : myScreen == (actScreen - 1)  && (scroll == 0 || overMe == 0) ,
    'next' : myScreen == (actScreen + 1)  && (scroll == 0 || overMe == 0) ,
    'next2' : myScreen >= (actScreen + 2)  && (scroll == 0 || overMe == 0)}"-->

  <div class="work-proj-item" :class="{'active' : myScreen == actScreen ,
    'past' : myScreen == (actScreen - 1)  && (scroll == 0 || overMe == 0) ,
    'next' : myScreen == (actScreen + 1)   ,
    'next2' : myScreen >= (actScreen + 2)  }">
      <div class="work-proj-content" :class="{'over' : over == 1}" v-on:mouseover="controlDragTool(1)" v-on:mouseout="controlDragTool(2)" v-on:click="goRoute()">
      <!--div class="work-proj-content"  v-on:click="goRoute()"-->

        <media-type :className="'work-proj-media'" :obj="projData.proj.cover" v-if="projData.proj.cover_mob.type == 'samedesktop'" :dynAlt="projData.proj.title[lang].name"> </media-type>
        <media-type :className="'work-proj-media'" :obj="projData.proj.cover_mob" v-if="projData.proj.cover_mob.type != 'samedesktop'" :dynAlt="projData.proj.title[lang].name"> </media-type>



      </div>

      <div class="work-proj-info" :class="{'scrolling' : scroll != 0}" >

        <div class="work-proj-info-aux">
          <h5 class="work-proj-client">{{projData.proj.client[0].name}}</h5>
          <h1 class="work-proj-title">{{projData.proj.title[lang].name}}</h1>
          <div class="work-proj-pagination">
            <span>{{ (projData.order + 1)}} <span class="barra">/</span> {{projData.total}}</span>

          </div>
        </div>



      </div>


    </div>
</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../../main';
    import MediaType from "./MediaType";


    export default {


        name: 'work-proj-module',
      components: {MediaType},
      props: ['projData',  'lang', 'actScreen', 'myScreen', 'scroll', 'overMe'],

        data() {
            return {

                loaded: false,
                 ready: false,
                visited: false,
              inside: 0,
              over: 0


            }
        },

        created() {
          const _this = this;

         // console.log(this.projData.proj.title[this.lang])


//console.log(this.projData.proj.cover_mob.type)





        },
      mounted() {


        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);


        this.ready = true;
        this.init();

        //EVENTBUS.$on('handOnOff', this.handOnOff);
        //EVENTBUS.$on('animCase', this.animCase);
      },

        destroyed() {

        },

        methods: {


              //EVENTBUS.$on('AAA', AAA);
              //EVENTBUS.$emit('AAA', 0);



            init(){


            },

          controlDragTool(n){

              this.over = n



            EVENTBUS.$emit('controlDragTool', n);
            //  console.log(this.myScreen, this.actScreen, this.scroll == 0, this.overMe == 0)
          //  EVENTBUS.$emit('controlDragTool', n);
            if(this.myScreen == this.actScreen && (this.scroll == 0 || this.overMe == 0)){
              //   EVENTBUS.$emit('controlDragTool', n);
            }

          },






          handOnOff(b){

              if(this.visited){
                if(b){


                 // TweenMax.to( '.work-proj-info', 0.3, { y: '100px', opacity: 0.5, force3D: true, ease: "circ.inOut"} );
                 // TweenMax.to( '.work-proj-media', 0.3, { scale:0.8,  force3D: true, ease: "circ.inOut"} );
                }else{
            //      TweenMax.to( '.work-proj-info', 0.7, { y: '0px', opacity: 1, force3D: true, ease: "circ.out"} );
              //    TweenMax.to( '.work-proj-media', 0.7, { scale: 1, force3D: true, ease: "circ.out"} );
                }
              }



           // TweenMax.to( '.sub-headline', 1, { x: pos2 +'%' , force3D: true, ease: "circ.out"} );

          },

          goRoute(){

              const _this = this;



              if(_this.myScreen == _this.actScreen && _this.scroll == 0){
                //_this.$router.push('project/' + _this.projData.proj.route);
              }

            _this.$router.push('project/' + _this.projData.proj.route);
         //     $('#dragme').hide();



          }


        },






    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/WorkProjModule.vue